<template>
    <div class="tournaments-holder">
        <div v-if="showNoOfferResults" class="group-game empty">
            <div class="error-offer-loading">
                <img class="odd-stats-img" src="../../../assets/img/error-offer-loading.svg" alt="">
                <p v-if="sportState == 'prematch'">{{$t('NOSPORTRESULTSFORSELECTEDDATE')}}</p>
                <p v-else>{{$t('NOLIVERESULTSFORSELECTEDDATE')}}</p>
            </div>
        </div>
        <template v-else>
            <template v-for="tour in matchesByTournaments">
                <div class="group-game" v-if="displayTournament(tour)" :key="tour.sportId+'|'+tour.categoryId+'|'+tour.tournamentId">
                    <div class="ggame-heading" :class="'game-heading-' + sportMapping[tour.sportId]">
                        <span class="ggame-heading-icon sport-icon lb-sport" :class="getSportIconClass(tour.sportId)"></span>
                        <h2 class="ggame-heading-text">{{tour.categoryName}} - {{tour.tournamentName}}</h2>
                    </div>
                    <div class="ggame-item" v-for="match in tour.matches" :key="match.matchId">
                        <div class="ggame-item-content">
                            <div class="ggame-item-text">
                                <div class="ggame-item-left">
                                    <div class="ggame-inner-top">
                                        <div class="ggame-item-teams results">
                                            <span class="first-team">{{matchesIn[match.matchId].teamNameOne || 'not defined'}} - {{matchesIn[match.matchId].teamNameTwo || 'not defined'}}</span>
                                        </div>
                                    </div>
                                    <div class="ggame-inner-bottom">
                                        <!--span class="ggame-item-matchid">{{matchesIn[match.matchId].code}}</span-->
                                        <span class="ggame-item-date">{{$predefinedLocalDateFormat(matchesIn[match.matchId].matchDate)}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="odds-container sport sport-results">
                                <template v-if="matchesIn[match.matchId].metaData != null">
                                    <div v-for="period in matchesIn[match.matchId].metaData.periods" :key="match.matchId+'|'+period.num" class="odd-value no-odd match-results">
                                        <div class="odd-head">{{period.num}}.{{$t(`${sportMapping[match.sportId].toUpperCase()}_PERIOD`).toLowerCase()}}</div>
                                        <div class="results-score">{{period.t1Scr}}:{{period.t2Scr}}</div>
                                    </div>
                                    <div class="odd-value no-odd match-results">
                                        <div class="odd-head">{{$t('FINALRESULT')}}</div>
                                        <div class="results-score">{{formatFinalResult(matchesIn[match.matchId].metaData)}}</div>
                                    </div>
                                </template>
                                <div v-else class="odd-value no-odd match-results">
                                    <div class="odd-head">{{$t('FINALRESULT')}}</div>
                                    <div class="results-score">-</div>
                                </div>
                                <div v-if="sportState == 'prematch' && false" class="odd-stats">
                                    <img class="odd-stats-img" src="../../../assets/img/statistics.svg" alt="">
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import
{
    mapGetters,
}
from 'vuex';

import moment from 'moment-timezone';

export default
{
    name: 'TournamentsResults',
    props: [
        'matchesIn',
        'categoriesin',
        'tournamentsin',
        'sportsselected',
        'categoryselected',
        'tournamentselected',
        'offerLoading',
    ],
    data()
    {
        return {
            matchesByTournaments: [],
            tournamentGroups: {},
        };
    },
    created()
    {
        const me = this;

        if (me.isMobile)
        {
            me.oddsShown = 3;
        }

        me.refreshOffer();
    },
    methods:
    {
        getSportIconClass(sportId)
        {
            const me = this;

            let sportIconName = 'noicon';
            if (me.sportMapping[sportId] !== undefined)
            {
                sportIconName = me.sportMapping[sportId];
            }

            return `sporticon-${sportIconName}`;
        },
        displayTournament(tournament)
        {
            const me = this;
            if (me.sportsselected.length === 0)
            {
                return true;
            }

            if (me.sportsselected.indexOf(tournament.sportId) === -1)
            {
                return false;
            }
            if (me.categoryselected[0] !== undefined && me.categoryselected.indexOf(tournament.categoryId) === -1)
            {
                return false;
            }
            if (me.tournamentselected[0] !== undefined && me.tournamentselected.indexOf(tournament.tournamentId) === -1)
            {
                return false;
            }

            return true;
        },
        formatResultValue(val)
        {
            if (val === '')
            {
                return '-';
            }

            return val;
        },
        formatFinalResult(metaData)
        {
            if (metaData.t1Scr == null || metaData.t2Scr == null)
            {
                return '-';
            }
            return `${metaData.t1Scr}:${metaData.t2Scr}`;
        },
        refreshOffer()
        {
            const me = this;

            me.matchesByTournaments = [];

            const tours = {};

            for (const matchId in me.matchesIn)
            {
                if (me.matchesIn !== undefined)
                {
                    const match = me.matchesIn[matchId];

                    if (tours[match.tournamentId] === undefined)
                    {
                        let tournamentSportOrder = 9999999;
                        let sportOrder = 10000;
                        let categoryOrder = 10000;
                        let categoryName = this.$t('UNDEFINEDCATEGORYNAME');
                        let tournamentOrder = 10000;
                        let tournamentName = this.$t('UNDEFINEDTOURNAMENTNAME');

                        if (me.sportTree.tournaments[match.tournamentId])
                        {
                            tournamentSportOrder = me.sportTree.tournaments[match.tournamentId].tournamentSportOrder;
                            tournamentOrder = me.sportTree.tournaments[match.tournamentId].tournamentOrder;
                            tournamentName = me.sportTree.tournaments[match.tournamentId].tournamentName;
                        }
                        if (me.sportTree.sports[match.sportId])
                        {
                            sportOrder = me.sportTree.sports[match.sportId].sportOrder;
                        }
                        if (me.sportTree.categories[match.categoryId])
                        {
                            categoryOrder = me.sportTree.categories[match.categoryId].categoryOrder;
                            categoryName = me.sportTree.categories[match.categoryId].categoryName;
                        }
                        tours[match.tournamentId] = {
                            matches: [],
                            tournamentId: match.tournamentId,
                            sportId: match.sportId,
                            categoryId: match.categoryId,
                            sportOrder,
                            categoryOrder,
                            tournamentOrder,
                            tournamentName,
                            categoryName,
                            tournamentSportOrder,
                        };
                    }

                    tours[match.tournamentId].matches.push(match);
                }
            }

            const toursIn = [];

            for (const tournamentId in tours)
            {
                if (tours[tournamentId] !== undefined)
                {
                    toursIn.push(tours[tournamentId]);
                }
            }

            if (toursIn.length > 1)
            {
                toursIn.stableSort((a, b) =>
                {
                    if (a.tournamentOrder < b.tournamentOrder)
                    {
                        return -1;
                    }

                    if (a.tournamentOrder > b.tournamentOrder)
                    {
                        return 1;
                    }

                    return 0;
                });

                toursIn.stableSort((a, b) =>
                {
                    if (a.categoryOrder < b.categoryOrder)
                    {
                        return -1;
                    }

                    if (a.categoryOrder > b.categoryOrder)
                    {
                        return 1;
                    }

                    return 0;
                });

                toursIn.stableSort((a, b) =>
                {
                    if (a.tournamentSportOrder != null && b.tournamentSportOrder == null)
                    {
                        return 1;
                    }

                    if (a.tournamentSportOrder == null && b.tournamentSportOrder != null)
                    {
                        return -1;
                    }

                    if (a.tournamentSportOrder == null && b.tournamentSportOrder == null)
                    {
                        return 0;
                    }

                    if (a.tournamentSportOrder < b.tournamentSportOrder)
                    {
                        return -1;
                    }

                    if (a.tournamentSportOrder > b.tournamentSportOrder)
                    {
                        return 1;
                    }

                    const aTn = a.tournamentName.trim();
                    const bTn = b.tournamentName.trim();

                    if (aTn < bTn)
                    {
                        return -1;
                    }

                    if (aTn > bTn)
                    {
                        return 1;
                    }

                    return 0;
                });

                toursIn.stableSort((a, b) =>
                {
                    if (a.sportOrder < b.sportOrder)
                    {
                        return -1;
                    }

                    if (a.sportOrder > b.sportOrder)
                    {
                        return 1;
                    }

                    return 0;
                });
            }

            for (let i = 0; i < toursIn.length; i += 1)
            {
                if (toursIn[i].matches.length < 2)
                {
                    continue;
                }

                toursIn[i].matches.stableSort((a, b) =>
                {
                    const matchOne = me.matchesIn[a.matchId];
                    const matchTwo = me.matchesIn[b.matchId];

                    if (matchOne !== undefined
                    && matchTwo === undefined)
                    {
                        return 1;
                    }

                    if (matchOne === undefined
                    && matchTwo !== undefined)
                    {
                        return -1;
                    }

                    if (matchOne === undefined
                    && matchTwo === undefined)
                    {
                        return 0;
                    }

                    const aStart = moment(matchOne.matchDate);
                    const bStart = moment(matchTwo.matchDate);

                    if (aStart < bStart)
                    {
                        return -1;
                    }

                    if (aStart > bStart)
                    {
                        return 1;
                    }

                    if (matchOne.teamNameOne < matchTwo.teamNameOne)
                    {
                        return -1;
                    }

                    if (matchOne.teamNameOne > matchTwo.teamNameOne)
                    {
                        return 1;
                    }

                    return 0;
                });
            }

            me.matchesByTournaments = toursIn;
        },
    },
    watch:
    {
        isMobile(val, oldVal)
        {
            const me = this;
            if (!val)
            {
                me.oddsShown = 6;
            }
            else
            {
                me.oddsShown = 3;
            }

            if (val !== oldVal)
            {
                me.refreshOffer();
            }
        },
        matchesIn:
        {
            handler()
            {
                const me = this;
                me.refreshOffer();
            },
            deep: true,
        },
        sportsselected()
        {
            const me = this;

            me.tournamentGroups = {

            };
            me.incrementByMatch = {

            };
            me.refreshOffer();
        },
        categoryselected()
        {
            const me = this;

            me.tournamentGroups = {

            };
            me.incrementByMatch = {

            };
            me.refreshOffer();
        },
        tournamentselected()
        {
            const me = this;

            me.tournamentGroups = {

            };
            me.incrementByMatch = {

            };
            me.refreshOffer();
        },
    },
    computed:
    {
        ...mapGetters(
            {
                match: 'selectedMatch',
                sportTree: 'sportTree',
                sportState: 'sportState',
                isMobile: 'isMobile',
                globals: 'globals',
            },
        ),
        sportMapping()
        {
            const me = this;
            let val = {};
            if (me.globals
            && me.globals.props
            && me.globals.props.sportMapping)
            {
                val = me.globals.props.sportMapping;
            }

            return val;
        },
        showNoOfferResults()
        {
            const me = this;

            if (Object.keys(me.matchesIn)[0] || me.offerLoading)
            {
                return false;
            }

            return true;
        },
    },
};
</script>
